import React, { Component } from 'react';
import { connect } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'; // v1.x
import { style } from 'assets/styles/styles';
import { setDimension } from 'redux/actions/windowDimension';
import { setLocation } from 'redux/actions/windowLocation';
import { setLocale } from 'redux/actions/i18n';
import { getLanguageFromBrowser } from 'libs/common';
import { getWindowDimension } from 'libs/windowDimension';
import { getToken } from 'libs/auth';
import { SESSION_TIMEOUT } from 'libs/constants';
import Notice from 'components/Notice';
import IdleModal from 'components/IdleModal';
import GoogleTagManager from 'components/GoogleTagManager';
import CleverTapWrapper from 'components/CleverTapWrapper';
import DeleteProcessingModal from 'views/DataPolicy/DeleteProcessingModal';
import { gTagTrackPageView } from 'libs/gTag';
import { IntlProvider, addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_es from 'react-intl/locale-data/es';
import locale_fr from 'react-intl/locale-data/fr';
import locale_ja from 'react-intl/locale-data/ja';
import locale_de from 'react-intl/locale-data/de';
import languages from 'i18n';

addLocaleData([...locale_en, ...locale_es, ...locale_fr, ...locale_ja, ...locale_de]);

const themeStyle = createMuiTheme(style);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIdleModal: false
    };
    window.appHistory = props.history;
  }

  componentWillMount() {
    this.handleWindowDimension();
    this.handleWindowLocation();
  }

  componentDidMount() {
    const { i18n: { info: { locale } } } = this.props;
    const _locale = getLanguageFromBrowser(locale);
    this.props.setLocale({ locale: _locale });
  }

  componentWillReceiveProps(nextProps) {
    const { i18n: { info: { locale } } } = this.props;
    const { i18n: { info: { locale: _locale } } } = nextProps;
    if (locale !== _locale) {
      this.props.setLocale({ locale: getLanguageFromBrowser(locale) });
    }
  }

  handleWindowDimension = () => {
    // updates dimension in store as window gets resize
    window.addEventListener('resize', () => {
      this.props.setDimension(getWindowDimension());
    });
  }

  handleWindowLocation = () => {
    // set default location
    this.props.setLocation(window.appHistory.location);
    // updates location in store as location gets changed
    window.appHistory.listen((location) => {
      gTagTrackPageView(location);
      this.props.setLocation(location);
    });
  }

  toggleIdleModal = () => {
    this.setState({ showIdleModal: !this.state.showIdleModal });
  }

  handleIdleAction = () => {
    if (getToken()) {
      this.setState({ showIdleModal: true });
    }
  }

  render() {
    const { route, deletionLog, i18n } = this.props;
    const { info: { locale } } = i18n;
    return (
      <IntlProvider locale={locale} messages={languages[locale]}>
        <MuiThemeProvider theme={themeStyle}>
          <div>
            <IdleTimer
              idleAction={this.handleIdleAction}
              timeout={SESSION_TIMEOUT.idleTime}
            >
              <div>
                <IdleModal
                  open={this.state.showIdleModal}
                  toggleModal={this.toggleIdleModal}
                />
                {renderRoutes(route.routes)}
                <Notice />
              </div>
            </IdleTimer>
            <GoogleTagManager />
            <CleverTapWrapper />
            {deletionLog && deletionLog.createdAt &&
              <DeleteProcessingModal
                isModalOpen
                handleClose={() => null}
              />
            }
          </div>
        </MuiThemeProvider>
      </IntlProvider>
    );
  }
}

App.propTypes = {
  route: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setDimension: PropTypes.func.isRequired,
  setLocation: PropTypes.func.isRequired,
  setLocale: PropTypes.func.isRequired,
  deletionLog: PropTypes.object,
  i18n: PropTypes.object.isRequired
};

App.defaultProps = {
  deletionLog: {}
};

export default connect(
  ({
    auth: { info },
    i18n
  }) => ({
    deletionLog: info && info.deletionLog,
    i18n
  }),
  { setDimension, setLocation, setLocale }
)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.jsx